var filter = function () {
    return function (input) {
        var output = angular.isDefined(input) ? input : "";
        if (output.length > 65) {
            return output.substring(0, 65) + "...";
        }
        else {
            return output;
        }
    };
};
var ɵ0 = filter;
export var ShowBannerMessageFilter = {
    name: 'showBannerMessage',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-show-banner-message.filter.js.map